import type { CitizenshipInfo } from 'types';

const RESIDENCY_PROOF_COUNTRIES = [
    'Belgium',
    'Czech Republic',
    'Denmark',
    'Greenland',
    'Faroe Islands',
    'Hong Kong',
    'Italy',
    'Japan',
    'Latvia',
    'Netherlands',
    'Aruba',
    'Bonaire Sint Eustatius and Saba',
    'Curaçao',
    'Sint Maarten',
    'Norway',
    'Slovakia',
    'Spain',
    'Sweden',
];

export const shouldShowResidencyProof = (
    isCanadianPlatform: boolean,
    countryOfResidence: string | null | undefined,
    citizenships: readonly Pick<CitizenshipInfo, 'country'>[] | null | undefined
): boolean => {
    return Boolean(
        isCanadianPlatform &&
        countryOfResidence &&
        citizenships?.some(
            ({ country }) =>
                RESIDENCY_PROOF_COUNTRIES.includes(country) && country !== countryOfResidence
        )
    );
};
